module.exports = __webpack_public_path__ + "static/media/sortiraj.080725ff.svg";